import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M10 14.1667C10.2361 14.1667 10.434 14.0868 10.5938 13.9271C10.7535 13.7674 10.8333 13.5694 '
  + '10.8333 13.3333C10.8333 13.0972 10.7535 12.8993 10.5938 12.7396C10.434 12.5799 10.2361 12.5 '
  + '10 12.5C9.76389 12.5 9.56597 12.5799 9.40625 12.7396C9.24653 12.8993 9.16667 13.0972 9.16667 '
  + '13.3333C9.16667 13.5694 9.24653 13.7674 9.40625 13.9271C9.56597 14.0868 9.76389 14.1667 10 '
  + '14.1667ZM10 10.8333C10.2361 10.8333 10.434 10.7535 10.5938 10.5937C10.7535 10.434 10.8333 '
  + '10.2361 10.8333 9.99999V6.66666C10.8333 6.43055 10.7535 6.23263 10.5938 6.07291C10.434 '
  + '5.91318 10.2361 5.83332 10 5.83332C9.76389 5.83332 9.56597 5.91318 9.40625 6.07291C9.24653 '
  + '6.23263 9.16667 6.43055 9.16667 6.66666V9.99999C9.16667 10.2361 9.24653 10.434 9.40625 '
  + '10.5937C9.56597 10.7535 9.76389 10.8333 10 10.8333ZM10 18.3333C8.84722 18.3333 7.76389 '
  + '18.1146 6.75 17.6771C5.73611 17.2396 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.76042 '
  + '14.2639 2.32292 13.25C1.88542 12.2361 1.66667 11.1528 1.66667 9.99999C1.66667 8.84721 '
  + '1.88542 7.76388 2.32292 6.74999C2.76042 5.7361 3.35417 4.85416 4.10417 4.10416C4.85417 '
  + '3.35416 5.73611 2.76041 6.75 2.32291C7.76389 1.88541 8.84722 1.66666 10 1.66666C11.1528 '
  + '1.66666 12.2361 1.88541 13.25 2.32291C14.2639 2.76041 15.1458 3.35416 15.8958 '
  + '4.10416C16.6458 4.85416 17.2396 5.7361 17.6771 6.74999C18.1146 7.76388 18.3333 8.84721 '
  + '18.3333 9.99999C18.3333 11.1528 18.1146 12.2361 17.6771 13.25C17.2396 14.2639 16.6458 '
  + '15.1458 15.8958 15.8958C15.1458 16.6458 14.2639 17.2396 13.25 17.6771C12.2361 18.1146 '
  + '11.1528 18.3333 10 18.3333ZM10 16.6667C11.8611 16.6667 13.4375 16.0208 14.7292 '
  + '14.7292C16.0208 13.4375 16.6667 11.8611 16.6667 9.99999C16.6667 8.13888 16.0208 6.56249 '
  + '14.7292 5.27082C13.4375 3.97916 11.8611 3.33332 10 3.33332C8.13889 3.33332 6.5625 3.97916 '
  + '5.27083 5.27082C3.97917 6.56249 3.33333 8.13888 3.33333 9.99999C3.33333 11.8611 3.97917 '
  + '13.4375 5.27083 14.7292C6.5625 16.0208 8.13889 16.6667 10 16.6667Z'

const ErrorCircleRoundedIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH} fill="currentColor" />
  </svg>
)

ErrorCircleRoundedIcon.propTypes = {
  className: PropTypes.string
}

ErrorCircleRoundedIcon.defaultProps = {
  className: 'tw:h-5 tw:w-5'
}

export default ErrorCircleRoundedIcon
